export default [
  {
    path: '/customerServices/thirdpartnarChatConf',
    name: 'thirdpartnarChatConf',
    meta: {
      title: '代运营对话配置'
    },
    component(resolve) {
      require(['COMPONENTS/customerServices/thirdpartnarChatConf/main.vue'], resolve)
    }
  },
  {
    path: '/customerServices/icyChatConf',
    name: 'icyChatConf',
    meta: {
      title: 'ICY对话配置'
    },
    component(resolve) {
      require(['COMPONENTS/customerServices/icyChatConf/main.vue'], resolve)
    }
  },
  {
    path: '/customerServices/chatQuickReply',
    name: 'chatQuickReply',
    meta: {
      title: '常用回复管理'
    },
    component(resolve) {
      require(['COMPONENTS/customerServices/chatQuickReply/main.vue'], resolve)
    }
  },
  {
    path: '/customerServices/csStatistics',
    name: 'csStatistics',
    meta: {
      title: '客服工作统计'
    },
    component(resolve) {
      require(['COMPONENTS/customerServices/csStatistics/main.vue'], resolve)
    }
  },
  {
    path: '/customerServices/csTimeStatistics',
    name: 'csTimeStatistics',
    meta: {
      title: '客服工时统计'
    },
    component(resolve) {
      require(['COMPONENTS/customerServices/csTimeStatistics/main.vue'], resolve)
    }
  },
]